import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

const Blogs = () => {
  return (
    <>
      <div id="blogs" className="w-full bg-gray-100">
        <div className="container mx-auto px-3 py-10 min-h-screen">
          <h1 className="text-5xl text-center">Blogs</h1>
          <div>
            <div class="text-gray-700 body-font overflow-hidden">
              <div class="container py-12 mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div class="bg-white rounded-md shadow-md border border-gray-100 p-5 lg:p-12 w-full flex flex-col items-start">
                    <span class="inline-block py-1 px-2 rounded bg-indigo-50 text-emerald-700 text-xs font-medium tracking-widest">
                      CATEGORY-1
                    </span>
                    <h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">
                      This is sample title-1
                    </h2>
                    <p class="leading-relaxed text-justify mb-8">
                      This is simple dummy description paragraph text. This is
                      simple dummy description paragraph text. This is simple
                      dummy description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text.
                    </p>
                    <div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full">
                      <a class="text-emerald-700 inline-flex items-center">
                        Learn More
                        <svg
                          class="w-4 h-4 ml-2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14"></path>
                          <path d="M12 5l7 7-7 7"></path>
                        </svg>
                      </a>
                      {/* <span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        1.2K
                      </span>
                      <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                        </svg>
                        6
                      </span> */}
                    </div>
                    <a class="inline-flex items-center">
                      <img
                        alt="blog"
                        src="https://dummyimage.com/104x104"
                        class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                      />
                      <span class="flex-grow flex flex-col pl-4">
                        <span class="title-font font-medium text-gray-900">
                          Holden Caulfield
                        </span>
                        <span class="text-gray-400 text-xs tracking-widest mt-0.5">
                          WEB DEVELOPER
                        </span>
                      </span>
                    </a>
                  </div>
                  <div class="bg-white rounded-md shadow-md border border-gray-100 p-12 w-full flex flex-col items-start">
                    <span class="inline-block py-1 px-2 rounded bg-indigo-50 text-emerald-700 text-xs font-medium tracking-widest">
                      CATEGORY-2
                    </span>
                    <h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">
                      This is sample title-2
                    </h2>
                    <p class="leading-relaxed text-justify mb-8">
                      This is simple dummy description paragraph text. This is
                      simple dummy description paragraph text. This is simple
                      dummy description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text.
                    </p>
                    <div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full">
                      <a class="text-emerald-700 inline-flex items-center">
                        Learn More
                        <svg
                          class="w-4 h-4 ml-2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14"></path>
                          <path d="M12 5l7 7-7 7"></path>
                        </svg>
                      </a>
                      {/* <span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        1.2K
                      </span>
                      <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                        </svg>
                        6
                      </span> */}
                    </div>
                    <a class="inline-flex items-center">
                      <img
                        alt="blog"
                        src="https://dummyimage.com/103x103"
                        class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                      />
                      <span class="flex-grow flex flex-col pl-4">
                        <span class="title-font font-medium text-gray-900">
                          Alper Kamu
                        </span>
                        <span class="text-gray-400 text-xs tracking-widest mt-0.5">
                          WEB DEVELOPER
                        </span>
                      </span>
                    </a>
                  </div>
                  <div class="bg-white rounded-md shadow-md border border-gray-100 p-12 w-full flex flex-col items-start">
                    <span class="inline-block py-1 px-2 rounded bg-indigo-50 text-emerald-700 text-xs font-medium tracking-widest">
                      CATEGORY-3
                    </span>
                    <h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">
                      This is sample title-3
                    </h2>
                    <p class="leading-relaxed text-justify mb-8">
                      This is simple dummy description paragraph text. This is
                      simple dummy description paragraph text. This is simple
                      dummy description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text.
                    </p>
                    <div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full">
                      <a class="text-emerald-700 inline-flex items-center">
                        Learn More
                        <svg
                          class="w-4 h-4 ml-2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14"></path>
                          <path d="M12 5l7 7-7 7"></path>
                        </svg>
                      </a>
                      {/* <span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        1.2K
                      </span>
                      <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                        </svg>
                        6
                      </span> */}
                    </div>
                    <a class="inline-flex items-center">
                      <img
                        alt="blog"
                        src="https://dummyimage.com/103x103"
                        class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                      />
                      <span class="flex-grow flex flex-col pl-4">
                        <span class="title-font font-medium text-gray-900">
                          Alper Kamu
                        </span>
                        <span class="text-gray-400 text-xs tracking-widest mt-0.5">
                          WEB DEVELOPER
                        </span>
                      </span>
                    </a>
                  </div>
                  <div class="bg-white rounded-md shadow-md border border-gray-100 p-12 w-full flex flex-col items-start">
                    <span class="inline-block py-1 px-2 rounded bg-indigo-50 text-emerald-700 text-xs font-medium tracking-widest">
                      CATEGORY-4
                    </span>
                    <h2 class="sm:text-3xl text-2xl title-font font-medium text-gray-900 mt-4 mb-4">
                      This is sample title-4
                    </h2>
                    <p class="leading-relaxed text-justify mb-8">
                      This is simple dummy description paragraph text. This is
                      simple dummy description paragraph text. This is simple
                      dummy description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text. This is simple dummy
                      description paragraph text.
                    </p>
                    <div class="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-auto w-full">
                      <a class="text-emerald-700 inline-flex items-center">
                        Learn More
                        <svg
                          class="w-4 h-4 ml-2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path d="M5 12h14"></path>
                          <path d="M12 5l7 7-7 7"></path>
                        </svg>
                      </a>
                      {/* <span class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        1.2K
                      </span>
                      <span class="text-gray-400 inline-flex items-center leading-none text-sm">
                        <svg
                          class="w-4 h-4 mr-1"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                        </svg>
                        6
                      </span> */}
                    </div>
                    <a class="inline-flex items-center">
                      <img
                        alt="blog"
                        src="https://dummyimage.com/103x103"
                        class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                      />
                      <span class="flex-grow flex flex-col pl-4">
                        <span class="title-font font-medium text-gray-900">
                          Alper Kamu
                        </span>
                        <span class="text-gray-400 text-xs tracking-widest mt-0.5">
                          WEB DEVELOPER
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
